import { Record } from 'immutable';

const ActivityRecord = Record({
  studentId: undefined,
  activityId: undefined,
  status: undefined, // NE, IP, CO
  statusDisplayName: undefined, // //New, In Progress, Complete
  activityType: undefined, // Essay, ShortAnswer
});

class Activity extends ActivityRecord {}

export default Activity;



// WEBPACK FOOTER //
// ./data/WritingAssignment/Activity/model.js